export default class CurrentShop {
    public isDaiberDe() {
        return document.body.classList.contains('portal');
    }

    public isLoggedInDaiberDe() {
        return document.body.classList.contains('daiber-account-area');
    }
}
